import classnames from 'classnames';
import React from 'react';
import { CSSTransition } from 'react-transition-group';

import IMobileMenu from '../../../../../../interfaces/mobile-menu';
import INavigationLink from '../../../../../../interfaces/navigation-link';

import Icon from '~/components/icon';
import PromoCodeDropdown from '../../../../../menu/promo-code-dropdown';
import DrawerMenuLinks from '../drawer-menu-links';
import SplitNavLinks from '../split-nav-links/split-nav-links';

import styles from './link-with-page.module.css';

interface IProps extends IMobileMenu {
  page: INavigationLink;
  label: string;
}

const LinksPage = ({
  page: { text, icon, subCategories: links },
  hideIcons,
  callback,
  pageClick,
  label
}: IProps): JSX.Element | null => {
  const [showLinksPage, setShowLiksPage] = React.useState(false);

  if (!text || !links?.length) {
    return null;
  }

  const renderSubComponent = (): JSX.Element => {
    const isPromoCodesDropdown = links.every(
      ({ icon: linkIcon }) => linkIcon?.length === 2
    );
    const isSplitDropdown = links.every(({ subCategories }) => !!subCategories);

    const renderSplitDropdown = () => {
      return (
        <div className={classnames(styles.page, styles.pageSplitNav)}>
					<SplitNavLinks
            links={links}
            callback={callback}
            label={`${label} - ${text}`} />

				</div>);

    };

    const renderPromoCodesDropdown = () => {
      return (
        <div className={classnames(styles.page, styles.pagePromoCodes)}>
					<PromoCodeDropdown
            links={links}
            callback={callback}
            label={`${label} - ${text}`} />

				</div>);

    };

    const renderDrawerMenuLinks = () => {
      return (
        <div className={styles.page}>
					<DrawerMenuLinks
            pages={links}
            trackMenu={callback}
            pageClick={pageClick}
            label={`${label} - ${text}`} />

				</div>);

    };

    const renderPage = () => {
      switch (true) {
        case !!isSplitDropdown:
          return renderSplitDropdown();

        case !!isPromoCodesDropdown:
          return renderPromoCodesDropdown();

        default:
          return renderDrawerMenuLinks();
      }
    };

    return (
      <CSSTransition
        in={showLinksPage}
        timeout={1000}
        classNames={{
          enter: styles.pageEnter,
          enterActive: styles.pageEnterActive,
          enterDone: styles.visible,
          exit: styles.pageExit,
          exitActive: styles.pageExitActive
        }}>

				{renderPage()}
			</CSSTransition>);

  };

  const renderIcon = () => {
    if (hideIcons || !icon) return;

    const [iconName, dimension = '16'] = icon.split(',');

    return (
      <div className={styles.iconContainer}>
				<Icon
          height={parseInt(dimension, 10)}
          width={parseInt(dimension, 10)}
          icon={iconName}
          className={styles.linkIcon} />

			</div>);

  };

  const handlePageClick = () => {
    setShowLiksPage((showLinks) => !showLinks);
    pageClick({ label: text, clickEvent: () => setShowLiksPage(false) });
  };

  return (
    <div>
			<div
        data-testid="page-links"
        onClick={handlePageClick}
        key={text}
        className={styles.link}>

				{renderIcon()}
				<div className={styles.linkText}>{text}</div>
				<div className={styles.arrow}></div>
			</div>
			{renderSubComponent()}
		</div>);

};

export default LinksPage;